import { EventEmitter, Injectable, OnInit } from '@angular/core';
import { AuthService } from '../vos/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SelectsService implements OnInit {
  user = JSON.parse(this.authService.getUserLoggedIn());
  value = new EventEmitter();
  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.verifyAcessUser();
  }
  selectTipoOrcamento() {
    return [
      { label: 'Home Care', value: 'Home Care' },
      { label: 'Remoção', value: 'Remocao' },
      { label: 'Evento', value: 'Evento' },
      { label: 'APH (Atendimento Pré Hospitalar)', value: 'APH' },
      { label: 'Tomada de Preço', value: 'Tomada de Preço' },
    ];
  }

  selectIndicacaoAcidente() {
    return [
      { label: 'Trabalho', value: '0' },
      { label: 'Trânsito', value: '1' },
      { label: 'Outros Acidentes', value: '2' },
      { label: 'Não Acidente', value: '9' },
    ];
  }

  selectRegimeInternacao() {
    return [
      { descricao: 'Hospitalar', codigo: '1' },
      { descricao: 'Hospital–dia', codigo: '2' },
      { descricao: 'Domiciliar', codigo: '3' },
    ];
  }

  selectTipoInternacao() {
    return [
      { descricao: 'Clínica', codigo: '1' },
      { descricao: 'Cirúrgica', codigo: '2' },
      { descricao: 'Obstétrica', codigo: '3' },
      { descricao: 'Pediátrica', codigo: '3' },
      { descricao: 'Psiquiátrica', codigo: '3' },
    ];
  }

  oneBy100() {
    return [
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: 3 },
      { label: '4', value: 4 },
      { label: '5', value: 5 },
      { label: '6', value: 6 },
      { label: '7', value: 7 },
      { label: '8', value: 8 },
      { label: '9', value: 9 },
      { label: '10', value: 10 },
      { label: '11', value: 11 },
      { label: '12', value: 12 },
      { label: '13', value: 13 },
      { label: '14', value: 14 },
      { label: '15', value: 15 },
      { label: '16', value: 16 },
      { label: '17', value: 17 },
      { label: '18', value: 18 },
      { label: '19', value: 19 },
      { label: '20', value: 20 },
      { label: '21', value: 21 },
      { label: '22', value: 22 },
      { label: '23', value: 23 },
      { label: '24', value: 24 },
      { label: '25', value: 25 },
      { label: '26', value: 26 },
      { label: '27', value: 27 },
      { label: '28', value: 28 },
      { label: '29', value: 29 },
      { label: '30', value: 30 },
      { label: '31', value: 31 },
      { label: '32', value: 32 },
      { label: '33', value: 33 },
      { label: '34', value: 34 },
      { label: '35', value: 35 },
      { label: '36', value: 36 },
      { label: '37', value: 37 },
      { label: '38', value: 38 },
      { label: '39', value: 39 },
      { label: '40', value: 40 },
      { label: '41', value: 41 },
      { label: '42', value: 42 },
      { label: '43', value: 43 },
      { label: '44', value: 44 },
      { label: '45', value: 45 },
      { label: '46', value: 46 },
      { label: '47', value: 47 },
      { label: '48', value: 48 },
      { label: '49', value: 49 },
      { label: '50', value: 50 },
      { label: '51', value: 51 },
      { label: '52', value: 52 },
      { label: '53', value: 53 },
      { label: '54', value: 54 },
      { label: '55', value: 55 },
      { label: '56', value: 56 },
      { label: '57', value: 57 },
      { label: '58', value: 58 },
      { label: '59', value: 59 },
      { label: '60', value: 60 },
      { label: '61', value: 61 },
      { label: '62', value: 62 },
      { label: '63', value: 63 },
      { label: '64', value: 64 },
      { label: '65', value: 65 },
      { label: '66', value: 66 },
      { label: '67', value: 67 },
      { label: '68', value: 68 },
      { label: '69', value: 69 },
      { label: '70', value: 70 },
      { label: '71', value: 71 },
      { label: '72', value: 72 },
      { label: '73', value: 73 },
      { label: '74', value: 74 },
      { label: '75', value: 75 },
      { label: '76', value: 76 },
      { label: '77', value: 77 },
      { label: '78', value: 78 },
      { label: '79', value: 79 },
      { label: '80', value: 80 },
      { label: '81', value: 81 },
      { label: '82', value: 82 },
      { label: '83', value: 83 },
      { label: '84', value: 84 },
      { label: '85', value: 85 },
      { label: '86', value: 86 },
      { label: '87', value: 87 },
      { label: '88', value: 88 },
      { label: '89', value: 89 },
      { label: '90', value: 90 },
      { label: '91', value: 91 },
      { label: '92', value: 92 },
      { label: '93', value: 93 },
      { label: '94', value: 94 },
      { label: '95', value: 95 },
      { label: '96', value: 96 },
      { label: '97', value: 97 },
      { label: '98', value: 98 },
      { label: '99', value: 99 },
      { label: '100', value: 100 },
    ];
  }

  selectConselhosProfissional() {
    return [
      { label: 'CRAS', value: '1' },
      { label: 'COREN', value: '2' },
      { label: 'CRF', value: '3' },
      { label: 'CRFA', value: '4' },
      { label: 'CREFITO', value: '5' },
      { label: 'CRM', value: '6' },
      { label: 'CRN', value: '7' },
      { label: 'CRO', value: '8' },
      { label: 'CRP', value: '9' },
      { label: 'Outros', value: '10' },
    ];
  }

  selectTipoAtendimento() {
    return [
      { codigo: '01', descricao: 'Remoção' },
      { codigo: '02', descricao: 'Pequena Cirurgia' },
      { codigo: '03', descricao: 'Outras Terapias' },
      { codigo: '04', descricao: 'Consulta' },
      { codigo: '05', descricao: 'Exame Ambulatorial' },
      { codigo: '06', descricao: 'Atendimento Domiciliar' },
      { codigo: '07', descricao: 'Internação' },
      { codigo: '08', descricao: 'Quimioterapia' },
      { codigo: '09', descricao: 'Radioterapia' },
      { codigo: '10', descricao: 'Terapia Renal Substitutiva(TRS)' },
      { codigo: '11', descricao: 'Pronto Socorro' },
      {
        codigo: '13',
        descricao: 'Pequeno atendimento(sutura, gesso e outros)',
      },
      { codigo: '14', descricao: 'Saúde Ocupacional - Admissional' },
      { codigo: '15', descricao: 'Saúde Ocupacional - Demissional' },
      { codigo: '16', descricao: 'Saúde Ocupacional - Periódico' },
      { codigo: '17', descricao: 'Saúde Ocupacional - Retorno ao trabalho' },
      { codigo: '18', descricao: 'Saúde Ocupacional - Mudança de função' },
      { codigo: '19', descricao: 'Saúde Ocupacional - Promoção a saúde' },
      { codigo: '20', descricao: 'Saúde Ocupacional - Beneficiário novo' },
      {
        codigo: '21',
        descricao: 'Saúde Ocupacional - Assistência a demitidos',
      },
      {
        codigo: '23',
        descricao: 'Exame',
      },
    ];
  }

  selectRegimeAtendimento() {
    return [
      { codigo: '01', descricao: 'Ambulatorial' },
      { codigo: '02', descricao: 'Domiciliar' },
      { codigo: '03', descricao: 'Internação' },
      { codigo: '04', descricao: 'Pronto Socorro' },
      { codigo: '05', descricao: 'TELESSAÚDE' },
    ];
  }

  selectMotivoEncerramento() {
    return [
      { codigo: '11', descricao: 'Alta Curado' },
      { codigo: '12', descricao: 'Alta Melhorado' },
      { codigo: '14', descricao: 'Alta a pedido' },
      {
        codigo: '15',
        descricao:
          'Alta com previsão de retorno para acompanhamento do paciente ',
      },
      { codigo: '16', descricao: 'Alta por Evasão' },
      { codigo: '18', descricao: 'Alta por outros motivos ' },
      { codigo: '19', descricao: 'Alta de Paciente Agudo em Psiquiatria' },
      {
        codigo: '21',
        descricao: 'Permanência, por características próprias da doença',
      },
      { codigo: '22', descricao: 'Permanência, por intercorrência ' },
      {
        codigo: '23',
        descricao: 'Permanência, por impossibilidade sócio-familiar',
      },
      {
        codigo: '24',
        descricao:
          'Permanência, por Processo de doação de órgãos, tecidos e células - doador vivo',
      },
      {
        codigo: '25',
        descricao:
          'Permanência, por Processo de doação de órgãos, tecidos e células - doador morto',
      },
      { codigo: '26', descricao: 'Permanência, por mudança de Procedimento' },
      { codigo: '27', descricao: 'Permanência, por reoperação' },
      { codigo: '28', descricao: 'Permanência, outros motivos' },
      { codigo: '31', descricao: 'Transferido para outro estabelecimento' },
      { codigo: '32', descricao: 'Transferência para Internação Domiciliar' },
      {
        codigo: '41',
        descricao:
          'Óbito com declaração de óbito fornecida pelo médico assistente',
      },
      {
        codigo: '42',
        descricao:
          'Óbito com declaração de Óbito fornecida pelo Instituto Médico Legal - IML',
      },
      {
        codigo: '43',
        descricao:
          'Óbito com declaração de Óbito fornecida pelo Serviço de Verificação de Óbito - SVO',
      },
      { codigo: '51', descricao: 'Encerramento Administrativo' },
      { codigo: '61', descricao: 'Alta da mãe/puérpera e do recém-nascido' },
      {
        codigo: '62',
        descricao: 'Alta da mãe/puérpera e permanência do recém-nascido',
      },
      {
        codigo: '63',
        descricao: 'Alta da mãe/puérpera e óbito do recém-nascido',
      },
      { codigo: '64', descricao: 'Alta da mãe/puérpera com óbito fetal' },
      { codigo: '65', descricao: 'Óbito da gestante e do concepto' },
      {
        codigo: '66',
        descricao: 'Óbito da mãe/puérpera e alta do recém-nascido',
      },
      {
        codigo: '67',
        descricao: 'Óbito da mãe/puérpera e permanência do recém-nascido',
      },
    ];
  }

  selectCbo() {
    return [
      { value: '201115', label: '201115 - Geneticista' },
      {
        value: '203015',
        label:
          '203015 - Pesquisador em biologia de microorganismos e parasitas',
      },
      { value: '213150', label: '213150 - Físico médico' },
      { value: '221105', label: '221105 - Biólogo' },
      { value: '225105', label: '225105 - Médico acupunturista' },
      { value: '225110', label: '225110 - Médico alergista e imunologista' },
      { value: '225148', label: '225148 - Médico anatomopatologista' },
      { value: '225115', label: '225115 - Médico angiologista' },
      { value: '225120', label: '225120 - Médico cardiologista' },
      { value: '225210', label: '225210 - Médico cirurgião cardiovascular' },
      {
        value: '225215',
        label: '225215 - Médico cirurgião de cabeça e pescoço',
      },
      {
        value: '225220',
        label: '225220 - Médico cirurgião do aparelho digestivo',
      },
      { value: '225225', label: '225225 - Médico cirurgião geral' },
      { value: '225230', label: '225230 - Médico cirurgião pediátrico' },
      { value: '225235', label: '225235 - Médico cirurgião plástico' },
      { value: '225240', label: '225240 - Médico cirurgião torácico' },
      { value: '225305', label: '225305 - Médico citopatologista' },
      { value: '225125', label: '225125 - Médico clínico' },
      { value: '225130', label: '225130 - Médico de família e comunidade' },
      { value: '225135', label: '225135 - Médico dermatologista' },
      { value: '225140', label: '225140 - Médico do trabalho' },
      { value: '225310', label: '225310 - Médico em endoscopia' },
      { value: '225145', label: '225145 - Médico em medicina de tráfego' },
      { value: '225150', label: '225150 - Médico em medicina intensiva' },
      { value: '225315', label: '225315 - Médico em medicina nuclear' },
      {
        value: '225320',
        label: '225320 - Médico em radiologia e diagnóstico por imagem',
      },
      {
        value: '225155',
        label: '225155 - Médico endocrinologista e metabologista',
      },
      { value: '225160', label: '225160 - Médico fisiatra' },
      { value: '225245', label: '225245 - Médico foniatra' },
      { value: '225165', label: '225165 - Médico gastroenterologista' },
      { value: '225170', label: '225170 - Médico generalista' },
      { value: '225175', label: '225175 - Médico geneticista' },
      { value: '225180', label: '225180 - Médico geriatra' },
      { value: '225250', label: '225250 - Médico ginecologista e obstetra' },
      { value: '225185', label: '225185 - Médico Hematologista' },
      { value: '225190', label: '225190 - Médico Hemoterapeuta' },
      { value: '225195', label: '225195 - Médico Homeopata' },
      { value: '225103', label: '225103 - Médico infectologista' },
      { value: '225106', label: '225106 - Médico legista' },
      { value: '225255', label: '225255 - Médico Mastologista' },
      { value: '225109', label: '225109 - Médico Nefrologista' },
      { value: '225260', label: '225260 - Médico neurocirurgião' },
      { value: '225350', label: '225350 - Médico neurofisiologista' },
      { value: '225112', label: '225112 - Médico neurologista' },
      { value: '225118', label: '225118 - Médico nutrologista' },
      { value: '225265', label: '225265 - Médico oftalmologista' },
      { value: '225121', label: '225121 - Médico oncologista' },
      {
        value: '225270',
        label: '225270 - Médico ortopedista e traumatologista',
      },
      { value: '225275', label: '225275 - Médico otorrinolaringologista' },
      { value: '225325', label: '225325 - Médico patologista clínico' },
      { value: '225124', label: '225124 - Médico pediatra' },
      { value: '225127', label: '225127 - Médico pneumologista' },
      { value: '225280', label: '225280 - Médico proctologista' },
      { value: '225133', label: '225133 - Médico psiquiatra' },
      { value: '225330', label: '225330 - Médico radioterapeuta' },
      { value: '225136', label: '225136 - Médico reumatologista' },
      { value: '225139', label: '225139 - Médico sanitarista' },
      { value: '225285', label: '225285 - Médico urologista' },
      { value: '223204', label: '223204 - Cirurgião dentista - auditor' },
      { value: '223208', label: '223208 - Cirurgião dentista - clínico geral' },
      { value: '223212', label: '223212 - Cirurgião dentista - endodontista' },
      {
        value: '223216',
        label: '223216 - Cirurgião dentista - epidemiologista',
      },
      {
        value: '223220',
        label: '223220 - Cirurgião dentista - estomatologista',
      },
      {
        value: '223224',
        label: '223224 - Cirurgião dentista - implantodontista',
      },
      {
        value: '223228',
        label: '223228 - Cirurgião dentista - odontogeriatra',
      },
      {
        value: '223232',
        label: '223232 - Cirurgião dentista - odontologista legal',
      },
      {
        value: '223236',
        label: '223236 - Cirurgião dentista - odontopediatra',
      },
      {
        value: '223240',
        label: '223240 - Cirurgião dentista - ortopedista e ortodontista',
      },
      {
        value: '223244',
        label: '223244 - Cirurgião dentista - patologista bucal',
      },
      { value: '223248', label: '223248 - Cirurgião dentista - periodontista' },
      {
        value: '223252',
        label: '223252 - Cirurgião dentista - protesiólogo bucomaxilofacial',
      },
      { value: '223256', label: '223256 - Cirurgião dentista - protesista' },
      { value: '223260', label: '223260 - Cirurgião dentista - radiologista' },
      {
        value: '223264',
        label: '223264 - Cirurgião dentista - reabilitador oral',
      },
      {
        value: '223268',
        label: '223268 - Cirurgião dentista - traumatologista bucomaxilofacial',
      },
      {
        value: '223272',
        label: '223272 - Cirurgião dentista de saúde coletiva',
      },
      { value: '223505', label: '223505 - Enfermeiro' },
      { value: '223605', label: '223605 - Fisioterapeuta geral' },
      { value: '223910', label: '223910 - Ortoptista' },
      { value: '223620', label: '223620 - Peripatologista' },
      { value: '223905', label: '223905 - Terapeuta ocupacional' },
      { value: '223710', label: '223710 - Nutricionista' },
      { value: '223810', label: '223810 - Fonoaudiólogo' },
      { value: '239425', label: '239425 - Psicopedagogo' },
      { value: '251510', label: '251510 - Psicólogo clínico' },
      { value: '251545', label: '251545 - Neuropsicólogo' },
      { value: '251550', label: '251550 - Psicanalista' },
      { value: '251605', label: '251605 - Assistente social' },
      { value: '322205', label: '322205 - Técnico de enfermagem' },
      { value: '322220', label: '322220 - Técnico de enfermagem psiquiátrica' },
      { value: '322225', label: '322225 - Instrumentador cirúrgico' },
      { value: '322230', label: '322230 - Auxiliar de enfermagem' },
      { value: '516210', label: '516210 - Cuidador de idosos' },
      { value: '225121', label: '225121 - Médico oncologista clínico' },
      { value: '225325', label: '225325 - Médico patologista' },
      {
        value: '223276',
        label: '223276 - Cirurgião dentista - odontologia do trabalho',
      },
      { value: '223280', label: '223280 - Cirurgião dentista - dentística' },
      {
        value: '223284',
        label:
          '223284 - Cirurgião dentista - disfunção temporomandibular e dor orofacial',
      },
      {
        value: '223288',
        label:
          '223288 - Cirurgião dentista - odontologia para pacientes com necessidades especiais',
      },
      {
        value: '223293',
        label: '223293 - Cirurgião-dentista da estratégia de saúde da família',
      },
      { value: '225122', label: '225122 - Médico cancerologista pediátrico' },
      {
        value: '225142',
        label: '225142 - Médico da estratégia de saúde da família',
      },
      { value: '225151', label: '225151 - Médico anestesiologista' },
      { value: '225203', label: '225203 - Médico em cirurgia vascular' },
      { value: '225290', label: '225290 - Médico cancerologista cirúrgico' },
      { value: '225295', label: '225295 - Médico cirurgião da mão' },
      {
        value: '225335',
        label: '225335 - Médico patologista clínico / medicina laboratorial',
      },
      { value: '225340', label: '225340 - Médico hemoterapeuta' },
      { value: '225345', label: '225345 - Médico hiperbarista' },
      { value: '223625', label: '223625 - Fisioterapeuta respiratória' },
      { value: '223630', label: '223630 - Fisioterapeuta neurofuncional' },
      { value: '223640', label: '223640 - Fisioterapeuta osteopata' },
      { value: '223645', label: '223645 - Fisioterapeuta quiropraxista' },
      { value: '223650', label: '223650 - Fisioterapeuta acupunturista' },
      { value: '223655', label: '223655 - Fisioterapeuta esportivo' },
      { value: '223660', label: '223660 - Fisioterapeuta do trabalho' },
      { value: '223435', label: '223435 - Farmacêutico industrial' },
      { value: '223430', label: '223430 - Farmacêutico em saúde pública' },
      { value: '223415', label: '223415 - Farmacêutico analista clínico' },
      { value: '223405', label: '223405 - Farmacêutico' },
      { value: '223420', label: '223420 - Farmacêutico de alimentos' },
      { value: '223440', label: '223440 - Farmacêutico toxicologista' },
      { value: '223445', label: '223445 - Farmacêutico hospitalar e clínico' },
      {
        value: '223425',
        label: '223425 - Farmacêutico práticas integrativas e complementares',
      },
      {
        value: '223565',
        label: '223565 - Enfermeiro da estratégia de saúde da família',
      },
      { value: '223560', label: '223560 - Enfermeiro sanitarista' },
      {
        value: '223555',
        label: '223555 - Enfermeiro puericultor e pediátrico',
      },
      { value: '223550', label: '223550 - Enfermeiro psiquiátrico' },
      { value: '223545', label: '223545 - Enfermeiro obstétrico' },
      { value: '223540', label: '223540 - Enfermeiro neonatologista' },
      { value: '223535', label: '223535 - Enfermeiro nefrologista' },
      { value: '223530', label: '223530 - Enfermeiro do trabalho' },
      { value: '223525', label: '223525 - Enfermeiro de terapia intensiva' },
      { value: '223520', label: '223520 - Enfermeiro de centro cirúrgico' },
      { value: '223515', label: '223515 - Enfermeiro de bordo' },
      { value: '223510', label: '223510 - Enfermeiro auditor' },
      { value: '223570', label: '223570 - Perfusionista' },
      { value: '223705', label: '223705 - Dietista' },
      { value: '223845', label: '223845 - Fonoaudiólogo em voz' },
      { value: '223830', label: '223830 - Fonoaudiólogo em linguagem' },
      { value: '223825', label: '223825 - Fonoaudiólogo em disfagia' },
      {
        value: '223835',
        label: '223835 - Fonoaudiólogo em motricidade orofacial',
      },
      { value: '223840', label: '223840 - Fonoaudiólogo em saúde coletiva' },
      { value: '223820', label: '223820 - Fonoaudiólogo em audiologia' },
      { value: '223815', label: '223815 - Fonoaudiólogo educacional' },
      { value: '223915', label: '223915 - Musicoterapeuta' },
      { value: '225154', label: '225154 - Médico antroposófico' },
      { value: '226305', label: '226305 - Musicoterapeuta' },
      {
        value: '999999',
        label: '999999 - CBO-S desconhecido ou não informado pelo solicitante',
      },
    ];
  }
  selectCaraterAtendimento() {
    return [
      { label: 'Eletivo', value: 1 },
      { label: 'Urgência/Emergência', value: 2 },
    ];
  }
  selectFormaPagamento() {
    return [
      { label: 'BOLETO', value: 'BOLETO' },
      { label: 'CARTÃO DE CRÉDITO', value: 'CARTÃO DE CRÉDITO' },
      { label: 'CARTÃO DE DÉBITO', value: 'CARTÃO DE DÉBITO' },
      { label: 'CHEQUE', value: 'CHEQUE' },
      { label: 'DINHEIRO', value: 'DINHEIRO' },
      { label: 'TRANSFERÊNCIA', value: 'TRANSFERÊNCIA' },
    ];
  }
  selectTipoPagamento() {
    return [
      { label: 'A Vista', value: 'A Vista' },
      { label: 'Parcela', value: 'Parcela' },
      { label: 'Pix', value: 'Pix' },
      { label: 'Transferência', value: 'Transferência' },
    ];
  }
  selectTipoPessoa() {
    return [
      { label: 'Cliente', value: 'Cliente' },
      { label: 'Fornecedor', value: 'Fornecedor' },
      // { label: "Funcionário", value: "Funcionário" },
      // { label: "Prestador", value: "Prestador" }
    ];
  }
  selectTipoConta() {
    return [
      { label: 'PAGAR', value: 'Pagar' },
      { label: 'RECEBER', value: 'Receber' },
      { label: 'TRANSFERÊNCIA', value: 'Transferência' },
    ];
  }

  selectSearchMenu() {
    return [
      {
        module: 'Área Clínica',
        value: 'Área Clínica',
        components: [
          // ----------------------------------------- IMPLANTAÇÃO ----------------------------------------------
          {
            label: 'Cadastro de pacientes',
            path: 'Área Clínica/Implantação/Cadastro de pacientes',
            value: '/main/patients/list',
          },
          {
            label: 'Cadastro do PAD',
            path: 'Área Clínica/Implantação/Cadastro do PAD',
            value: '/main/operacao/pad',
          },
          {
            label: 'Cadastro de Orçamentos',
            path: 'Área Clínica/Implantação/Cadastro de Orçamentos',
            value: '/main/budgets/list',
          },
          {
            label: 'Ativação de Paciente',
            path: 'Área Clínica/Implantação/Ativação de Paciente',
            value: '/main/contracts/list',
          },
          {
            label: 'Cadastro de Escalas',
            path: 'Área Clínica/Implantação/Cadastro de Escalas',
            value: ['/main/scales/escalas', 'new'],
          },
          {
            label: 'Transcrição de Medicamentos',
            path: 'Área Clínica/Implantação/Transcrição de Medicamentos',
            value: '/main/medication-transcripts/list',
          },
          // ----------------------------------------- ESCALA ----------------------------------------------
          {
            label: 'Monitoramento de escalas',
            path: 'Área Clínica/Escala/Monitoramento',
            value: '/main/monitoring',
          },
          {
            label: 'Controle de Folgas/Furos',
            path: 'Área Clínica/Escala/Controle de Folgas/Furos',
            value: '/main/bore-clearance/list',
          },
          {
            label: 'Evolução Mensal',
            path: 'Área Clínica/Escala/Evolução Mensal',
            value: '/main/supplier-reports/my-reports/list',
          },
          //
          // ----------------------------------------- ESTATÍSTICAS ----------------------------------------------
          {
            label: 'Timeline do paciente',
            path: 'Área Clínica/Estatísticas/Timeline do paciente',
            value: '/main/operacao/management-control',
          },
          {
            label: 'Área do Convênio',
            path: 'Área Clínica/Estatísticas/Área do Convênio',
            value: '/main/customer-area/list',
          },
          {
            label: 'Dashboard de Orçamento',
            path: 'Área Clínica/Estatísticas/Dashboard de Orçamento',
            value: '/main/bidding/dashboard',
          },
          {
            label: 'Dashboard de Atendimento',
            path: 'Área Clínica/Estatísticas/Dashboard de Atendimento',
            value: '/main/clinical-area/dashboard',
          },
          //
          // ----------------------------------------- OPERAÇÃO -------------------------------------------------
          {
            label: 'Acompanhamento do Paciente',
            path: 'Área Clínica/Operação/Acompanhamento do Paciente',
            value: '/main/monitoring/clinical-evolution',
          },
          {
            label: 'Assistência Farmacéutica',
            path: 'Área Clínica/Operação/Assistência Farmacéutica',
            value: '/main/home',
          },
          {
            label: 'Documentos Manuais',
            path: 'Área Clínica/Operação/Documentos Manuais',
            value: '/main/documents/list',
          },
          {
            label: 'Ocorrências Resolvidas',
            path: 'Área Clínica/Operação/Ocorrências Resolvidas',
            value: '/main/operacao/ocorrencias-resolvidas',
          },
          {
            label: 'Relatório',
            path: 'Área Clínica/Operação/Relatório',
            value: '/main/general-reports/list',
          },
          //
        ],
      },
      {
        module: 'Financeiro',
        value: 'Financeiro',
        components: [
          // ----------------------------------------- FINANCEIRO -------------------------------------------------
          {
            label: 'Cotações de compras',
            path: 'Área Administrativa/Financeiro/Cotações de compras',
            value: '/main/purchasing-quotations/list',
          },
          {
            label: 'Fluxo de caixa',
            path: 'Área Administrativa/Financeiro/Fluxo de caixa',
            value: '/main/cash-flows/list',
          },
          {
            label: 'Relatórios financeiro',
            path: 'Área Administrativa/Financeiro/Relatório financeiro',
            value: '/main/financial/reports/list',
          },
          // ----------------------------------------- FINANCEIRO - CADASTROS -------------------------------------------------
          {
            label: 'Cadastro de categoria de naturezas',
            path: 'Área Administrativa/Financeiro/Cadastros/Cadastro de categoria de naturezas',
            value: '/main/categories-natures/list',
          },
          {
            label: 'Cadastro de contas bancárias',
            path: 'Área Administrativa/Financeiro/Cadastros/Cadastro de contas bancárias',
            value: '/main/bank-accounts/list',
          },
          {
            label: 'Cadastro de fornecedores',
            path: 'Área Administrativa/Financeiro/Cadastros/Cadastro de fornecedores',
            value: '/main/suppliers/list',
          },
          {
            label: 'Cadastro de naturezas',
            path: 'Área Administrativa/Financeiro/Cadastros/Cadastro de naturezas',
            value: '/main/natures/list',
          },
          //
          // ----------------------------------------- FINANCEIRO - PAGAMENTOS -------------------------------------------------
          {
            label: 'Contas à Pagar',
            path: 'Área Administrativa/Financeiro/Pagamentos/Contas à Pagar',
            value: '/main/accounts/payable/list',
          },
          {
            label: 'Contas à Receber',
            path: 'Área Administrativa/Financeiro/Pagamentos/Contas à Receber',
            value: '/main/accounts/receivables/list',
          },
          {
            label: 'Cadastro de pagamentos (CNAB)',
            path: 'Área Administrativa/Cadastros/Cadastro de pagamentos (CNAB)',
            value: '/main/cnab-payments/list',
          },
          //
        ],
      },
      {
        module: 'Gestão Orçamentária',
        value: 'Cadastro de Contratos',
        components: [
          {
            label: 'Área Convênio',
            path: 'Área Administrativa/Cadastro de Contratos/Área Convênio',
            value: '/main/customer-area/list',
          },
          {
            label: 'Cadastro de contratante',
            path: 'Área Administrativa/Cadastro de Contratos/Cadastro de contratante',
            value: '/main/clients/list',
          },
          {
            label: 'Cadastro de custos',
            path: 'Área Administrativa/Cadastro de Contratos/Cadastro de custos',
            value: '/main/costs/list',
          },
          {
            label: 'Cadastro de pacientes',
            path: 'Área Administrativa/Cadastro de Contratos/Cadastro de pacientes',
            value: '/main/patients/list',
          },
          {
            label: 'Lista de responsáveis',
            path: 'Área Administrativa/Cadastro de Contratos/Lista de responsáveis',
            value: '/main/responsibles/list',
          },
          {
            label: 'Cadastro de serviços',
            path: 'Área Administrativa/Cadastro de Contratos/Cadastro de serviços',
            value: '/main/services/list',
          },
          {
            label: 'Cadastro de pacotes',
            path: 'Área Administrativa/Cadastro de Contratos/Cadastro de pacotes',
            value: '/main/packages/list',
          },
          {
            label: 'Cadastro de impostos',
            path: 'Área Administrativa/Cadastro de Contratos/Orçamentos/Cadastro de impostos',
            value: '/main/taxes/list',
          },
          {
            label: 'TISS',
            path: 'Área Administrativa/Gestão Orçamentária/Orçamentos/TISS',
            value: '/main/tiss/list',
          },
        ],
      },
      {
        module: 'TI',
        value: 'TI',
        components: [
          {
            label: 'Acesso de convênio',
            path: 'Área Administrativa/TI/Acesso de convênio',
            value: '/main/ti/acessos/cliente',
          },
          {
            label: 'Acesso de colaboradores',
            path: 'Área Administrativa/TI/Acesso de colaboradores',
            value: '/main/ti/acessos/profissional',
          },
          {
            label: 'Acesso de responsáveis',
            path: 'Área Administrativa/TI/Acesso de responsáveis',
            value: '/main/ti/acessos/responsavel',
          },
        ],
      },
      {
        module: 'RH',
        value: 'RH',
        components: [
          // ----------------------------------------- RH/DP -------------------------------------------------
          {
            label: 'Cadastro de benefícios, cargos e etc.',
            path: 'Área Administrativa/RH / DP/Cadastro de benefícios, cargos e etc',
            value: '/main/auxiliary-records',
          },
          {
            label: 'Ponto Eletrônico',
            path: 'Área Administrativa/RH / DP/Ponto Eletrônico',
            value: '/main/external-electronic-points/list',
          },
          {
            label: 'Dashboard de profissionais',
            path: 'Área Administrativa/RH / DP/Visão Geral',
            value: '/main/overview',
          },
          //
          // ----------------------------------------- RH/DP - PROFISSIONAIS -------------------------------------------------
          {
            label: 'Cadastro de profissionais externos',
            path: 'Área Administrativa/RH / DP/Profissionais/Cadastro de profissionais externos',
            value: '/main/service-providers/list',
          },
          {
            label: 'Cadastro de profissionais internos',
            path: 'Área Administrativa/RH / DP/Profissionais/Cadastro de profissionais internos',
            value: '/main/professionals/list',
          },
          {
            label: 'Recrutamento de profissionais',
            path: 'Área Administrativa/RH / DP/Profissionais/Recrutamento de profissionais',
            value: '/main/users/list',
          },
          {
            label: 'Relatórios de profissionais externos',
            path: 'Área Administrativa/RH / DP/Profissionais/Relatórios de profissionais externos',
            value: '/main/reports-providers/list',
          },
          //
          // ----------------------------------------- RH/DP - PAGAMENTOS -------------------------------------------------
          {
            label: 'Folha Externa',
            path: 'Área Administrativa/RH / DP/Pagamentos/Folha Externa',
            value: '/main/outer-sheets/list',
          },
          {
            label: 'Folha Interna',
            path: 'Área Administrativa/RH / DP/Pagamentos/Folha Interna',
            value: '/main/payrolls/internal-payments/list',
          },
          //
        ],
      },
      {
        module: 'Agendamento',
        value: 'Agendamento',
        components: [
          // ----------------------------------------- AGENDAMENTOS -------------------------------------------------
          {
            label: 'Cadastro de agendamento',
            path: 'Área Administrativa/Agendamentos/Cadastro de agendamento',
            value: '/main/calendar-room-meeting/list',
          },
          {
            label: 'Salas de Reunião',
            path: 'Área Administrativa/Agendamentos/Salas de Reunião',
            value: '/main/meeting-rooms/list',
          },
          //
        ],
      },
      {
        module: 'Diretoria',
        value: 'Diretoria',
        components: [
          // ----------------------------------------- DIRETORIA -------------------------------------------------
          {
            label: 'Configurações da empresa',
            path: 'Área Administrativa/Diretoria/Configurações da empresa',
            value: '/main/directors/company',
          },
          {
            label: 'Lista de pagamentos',
            path: 'Área Administrativa/Diretoria/Lista de pagamentos',
            value: '/main/directors/approve-payments/list',
          },
          //
        ],
      },
      {
        module: 'Compras',
        value: 'Compras',
        components: [
          // ----------------------------------------- COMPRAS -------------------------------------------------
          {
            label: 'Cotações',
            path: 'Suprimentos/Compras/Cotações',
            value: '/main/quotations/list',
          },
          {
            label: 'Fornecedores',
            path: 'Suprimentos/Compras/Fornecedores',
            value: '/main/suppliers/list',
          },
          {
            label: 'Locação',
            path: 'Suprimentos/Compras/Locação',
            value: '/main/leases/list',
          },
          {
            label: 'MAT/MED - Equipamentos',
            path: 'Suprimentos/Compras/MAT/MED - Equipamentos',
            value: '/main/products/list',
          },
          //
          // ----------------------------------------- COMPRAS - TABELAS -------------------------------------------------
          {
            label: 'Brasindice',
            path: 'Suprimentos/Compras/Tabelas/Brasindice',
            value: '/main/tables/brasindice',
          },
          {
            label: 'Simpro',
            path: 'Suprimentos/Compras/Tabelas/Simpro',
            value: '/main/tables/simpro',
          },
          //
        ],
      },
      {
        module: 'Requisição Material',
        value: 'Requisição Material',
        components: [
          // ----------------------------------------- REQUISIÇÕES -------------------------------------------------
          {
            label: 'Pedido de Compra',
            path: 'Suprimentos/Requisições/Pedido de Compra',
            value: '/main/purchase-orders/list',
          },
          {
            label: 'Requisição de Material',
            path: 'Suprimentos/Requisições/Requisição de Material',
            value: '/main/material-requisition/list',
          },
          //
        ],
      },
      {
        module: 'Estoque',
        value: 'Estoque',
        components: [
          // ----------------------------------------- ESTOQUE -------------------------------------------------
          {
            label: 'Entrada',
            path: 'Suprimentos/Estoque/Entrada',
            value: '/main/stock/entries/list',
          },
          {
            label: 'Produtos',
            path: 'Suprimentos/Estoque/Produtos',
            value: '/main/stock/products/list',
          },
          {
            label: 'Relatório',
            path: 'Suprimentos/Estoque/Relatório',
            value: '/main/stock/reports/list',
          },
          {
            label: 'Saída',
            path: 'Suprimentos/Estoque/Saída',
            value: '/main/stock/exits/list',
          },
          //
        ],
      },
      {
        module: 'Vendas',
        value: 'Estoque',
        components: [
          // ----------------------------------------- VENDAS -------------------------------------------------
          {
            label: 'Clientes (Tomador)',
            path: 'Suprimentos/Vendas/Clientes (Tomador)',
            value: '/main/clients/list',
          },
          {
            label: 'Venda',
            path: 'Suprimentos/Vendas/Venda',
            value: '/main/farmacia/vendas',
          },
          //
        ],
      },
      {
        module: 'Faturamento',
        value: 'Faturamento',
        components: [
          {
            label: 'PAs (Pacientes Ativos)',
            path: 'Área Administrativa/Faturamento/PAs (Pacientes Ativos)',
            value: '/main/contracts/list',
          },
          {
            label: 'Orçamento',
            path: 'Área Administrativa/Faturamento/Orçamento',
            value: '/main/budgets/list',
          },
          {
            label: 'TISS',
            path: 'Área Administrativa/Faturamento/TISS',
            value: '/main/tiss/list',
          },
          {
            label: 'Medições (Capa de Lote)',
            path: 'Área Administrativa/Faturamento/Medições (Capa de Lote)',
            value: '/main/metering/list',
          },
        ],
      },
    ];
  }

  verifyAcessUser() {
    let acessUser: any = [];
    for (let i = 0; i <= this.user.user.acessos.length; i++) {
      let quantityAcess: any = [];
      quantityAcess = this.selectSearchMenu().find(
        (x) => x.module === this.user?.user.acessos[i]?.nome
      );

      if (quantityAcess) {
        acessUser.push(quantityAcess);
      }
    }
    return acessUser;
  }
}
